import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const AdminTableItem = ({ item, ind }) => {
    const [showModal, setShowModal] = useState(false);

    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <>
            <tr style={{cursor: 'pointer'}}>
                <td>{ind + 1}</td>
                <td><p className="admin-table__title">{item?.sku}</p></td>
                <td>{item?.name}</td>
                <td>
                    {item?.id ? (
                        <a href={`https://kanzler.kg/catalog/product/${item.id}`} target="_blank"
                           rel="noopener noreferrer">
                            {`https://kanzler.kg/catalog/product/${item.id}`}
                        </a>
                    ) : (
                        '-'
                    )}
                </td>
                <td>
                    {item.thumb ? (
                        <img
                            style={{maxWidth: '40px', maxHeight: '29px', cursor: 'zoom-in'}}
                            src={item.thumb}
                            alt="thumb"
                            onClick={handleOpen}
                        />
                    ) : '-'}
                </td>
                <td>{item?.brand}</td>
                <td style={{color: item?.found ? 'inherit' : 'red'}}>
                    {item?.found ? 'Да' : 'Нет'}
                </td>

            </tr>

            {/* Modal for full image */}
            <Modal show={showModal} onHide={handleClose} centered size="lg">
                <Modal.Body className="text-center">
                    <img
                        src={item.img}
                        alt="full"
                        style={{ maxWidth: '100%', maxHeight: '80vh' }}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AdminTableItem;
